export default __webpack_public_path__ + "static/media/GoodMannersAtSchool_00.ce9cacf6.png";